//Note: Important!!!
//import the class here, not the object
import {HttpService} from 'service/HttpService';

import {OrderAction} from 'AppAction';
import AppConstants from 'AppConstants';
import Dispatcher from 'service/Dispatcher';


const BASE_URL = AppConstants.BASE_API_URL+"/adcampaign";

class AdAPI extends HttpService { 

	getChetanCampaignOrders() {
		this.get("/chetan-camper/orders", response => {
			Dispatcher.dispatch({
				type: OrderAction.LOAD_CHETAN_CAMPAGIN_ORDERS,
				orders: response.data
			});
		});
	}


	getCodersMerch(callback) {
		this.get("/promotion/merch?code=CODER_MERCH", response => {
			callback(response.data);
		});
	}

	getNepalThemeMerch(callback) {
		this.get("/promotion/merch?code=NEPAL_MERCH", response => {
			callback(response.data);
		});
	}

	subscribeToCodersMerchCoupon(emailAddress, callback) {
		const postData = {emailAddress: emailAddress};
		this.post("/coding-merch-coupon", postData, response => {
			Dispatcher.dispatchAnAlert(response.data);

			if(typeof callback === 'function')
				callback(true);
		}, error => {
			if(typeof callback === 'function')
				callback(false);

			this.defaultErrorHandler(error);
		});
	}
}


export default new AdAPI(BASE_URL);


// WEBPACK FOOTER //
// ./src/service/api/AdAPI.js